import { Card, Carousel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SlidePrompt from './SlidePrompt';

function SlideCarousel({
  carouselIndex,
  onSlideChange,
  tenantPrompts,
  defaultPrompts,
  setPromptError,
  setShowPromptError,
}) {
  return (
    <Carousel
      activeIndex={carouselIndex}
      interval={null}
      indicators={false}
      onSelect={onSlideChange}
    >
      {tenantPrompts.map((prompt, promptIdx) => {
        const slideUrl = prompt.videoPromptUrl;
        const defaultSlideUrl = defaultPrompts[promptIdx].videoPromptUrl;

        const slideName = `slide-${promptIdx}`;
        return (
          <Carousel.Item key={slideName}>
            <Card className="slide-card" style={{ position: 'relative' }}>
              <SlidePrompt
                name={slideName}
                slideUrl={slideUrl}
                defaultSlideUrl={defaultSlideUrl}
                setShowPromptError={setShowPromptError}
                setPromptError={setPromptError}
              />
            </Card>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

SlideCarousel.propTypes = {
  carouselIndex: PropTypes.number,
  onSlideChange: PropTypes.func,
  tenantPrompts: PropTypes.array,
  defaultPrompts: PropTypes.array,
  setPromptError: PropTypes.func,
  setShowPromptError: PropTypes.func,
};

export default SlideCarousel;
